// Default duration per letter for text animations
export const durationPerLetter = 250;

export default {
  durationPerLetter,
};
